export default __webpack_public_path__ + "static/media/MGM2023091302.09ddfd14.jpg";